import { useMutation, useQuery } from "@tanstack/react-query"
import axios from "@/utils/axios"
import { SubscriptionPlanType } from "../domainModels/subscriptionPlan"
import { SubscriptionsResponseType } from "../responseBuilders/subscription"

export const useCreateStripeSession = () => {
  return useMutation({
    mutationFn: ({
      email,
      isYearly,
      planType
    }: {
      email: string
      isYearly: boolean
      planType?: SubscriptionPlanType
    }) =>
      axios
        .post<{
          success?: boolean
          sessionId?: string
          url?: string
          subscriptionId?: string
          message?: string
        }>("/subscriptions/create-stripe-session", {
          email,
          isYearly,
          ...(planType !== undefined ? { planType } : {})
        })
        .then((r) => r.data)
  })
}

export const useSearchSubscriptions = (userId: string) => {
  return useQuery({
    queryKey: ["subscriptions", "search", userId],
    queryFn: async () => {
      const response = await axios.get<SubscriptionsResponseType>("/subscriptions")
      return response.data
    },
    enabled: !!userId
  })
}

export const useCreateCustomerPortalSession = () => {
  return useMutation<{ url: string }, Error, { returnUrl?: string } | void>({
    mutationFn: async (body) => {
      const response = await axios.post<{ url: string }>(
        "/subscriptions/create-customer-portal-session",
        body ?? {}
      )
      return response.data
    }
  })
}
